import React from "react";
import Page from "../../common/page/Page.js";
import useTranslationAdmin from "../useTranslationAdmin.js";
import useShowLoader from "../../common/loading-widgets/useShowLoader.js";
import WithRedirectionUserIsAuthorized from "../../authentication-ui/WithRedirectionUserIsAuthorized.js";
import RecruiterListBlock from "./RecruiterListBlock.js";


export default function RecruiterListPage(/*props*/) {
  const { t, loading: tLoading } = useTranslationAdmin();
  useShowLoader(tLoading, "RecruiterListPage");

  return (
    <WithRedirectionUserIsAuthorized
      yes={() => (
        <Page className="RecruiterListPage">
          <Page.Title
            text={t("admin:admin_recruiter_list_title")}
            loading={tLoading}
          />
          <Page.Content>
            <RecruiterListBlock />
          </Page.Content>
        </Page>
      )}
    />
  );
}
